export * from './use-get-subdomains-query.hook';
